import { apiMap } from '../utilities';
import { storageService, headerKey, restClient } from '.';

const userService = {
  update: (data: any) => {
    storageService.get(storageService.ACCESS_TOKEN).then((userToken): any => {
      if (userToken) {
        restClient.setHeader(headerKey.AccessToken, String(userToken));
        return restClient.makePutRequest(apiMap.update(data.userID), data).then((response) => {
          if (response) {
            storageService.set(storageService.user, JSON.stringify(response.user));
          }
        });
      }
    });
  },

  updateUser: (data: any) => {
    return restClient.makePutRequest(apiMap.update(data.userID), data);
  },

  getPrescriptions: (userID: string) => {
    return restClient.makeGetRequest(apiMap.getPrescriptions(userID));
  },
  getPrescriptionSamsung: (visitID: string) => {
    return restClient.makeGetRequest(apiMap.getPrescriptionSamsung(visitID), {
      headers: {
        accept: 'text/html',
      },
    });
  },

  getPdfUrl(url: string) {
    return restClient.makeGetRequest(apiMap.getPdfUrl(url), {
      headers: {
        [headerKey.AuthToken]: restClient.getHeader(headerKey.AccessToken),
      },
    });
  },

  diagnosticOrder(body: any) {
    return restClient.makePostRequest(apiMap.diagnosticOrder(), body);
  },

  getDashboardData(userID: string) {
    return restClient.makeGetRequest(apiMap.getDashboardData(userID));
  },

  getUserPatients({ userID, clinicID, doctorID, mobileNumber }: any) {
    return restClient.makeGetRequest(apiMap.getUserPatients(userID), {
      clinicID,
      doctorID,
      mobileNumber,
    });
  },

  createNewPatient(body: any) {
    return restClient.makePostRequest(apiMap.createNewPatient(), body);
  },

  getUserDetailsFromToken(accessToken: string) {
    return restClient.makeGetRequest(apiMap.getUserDetailsFromToken(accessToken));
  },
};

export default userService;